import { render, staticRenderFns } from "./EditEmailTemplateDialog.vue?vue&type=template&id=07bb8b40&lang=pug&"
import script from "./EditEmailTemplateDialog.vue?vue&type=script&lang=ts&"
export * from "./EditEmailTemplateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports